export default __webpack_public_path__ + "static/media/T8-output2.31bf8301.png";